import { render, staticRenderFns } from "./TicketCard.vue?vue&type=template&id=0cf2a8ce&scoped=true"
import script from "./TicketCard.vue?vue&type=script&lang=js"
export * from "./TicketCard.vue?vue&type=script&lang=js"
import style0 from "./TicketCard.vue?vue&type=style&index=0&id=0cf2a8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf2a8ce",
  null
  
)

export default component.exports